import React from 'react';
import PageBanner from "@/components/pageBanner";
import {Heading} from "@/components/ui/heading";
import RegistrationMovie from "../../assets/movies/support/video-tips-for-beginners/1_registraction.mp4";
import SubscriptionMovie from "../../assets/movies/support/video-tips-for-beginners/2_subscription.mp4";
import SettingsMovie from "../../assets/movies/support/video-tips-for-beginners/3_settings_ai.mp4";

const SupportVideo = () => {
    return (
        <>
            <PageBanner title="Video Tips For Beginners" slug="support-video"/>
            <section className="generic-container py-14">

                <ul className={"list-disc pl-5"}>
                    <li>
                        <p className="font-bold">How Individual Settings Affect the AI Assistant's Performance</p>
                        <p>
                            Understand how each parameter influences the AI Assistant's decisions! In this video, we’ll
                            show you how adjusting settings such as signal sensitivity and length, along with technical
                            analysis, shapes how the AI Assistant analyzes the market and generates signals.
                        </p>
                    </li>
                    <li className="mt-4">
                        <p className="font-bold">How to Adjust the AI Assistant to the Current Chart</p>
                        <p>
                            Learn how to quickly and effectively configure the AI Assistant for a specific chart! We’ll
                            show you how to tailor settings and real-time market analysis to obtain the most precise
                            signals.
                        </p>
                    </li>
                    <li className="mt-4">
                        <p className="font-bold">The Magic Technical Analysis Button – Full Analysis in One Click!</p>
                        <p>
                            Want a complete market overview in seconds? This video will demonstrate how the magic
                            technical analysis button works, instantly filtering key levels and trends, helping you
                            automate chart analysis.
                        </p>
                    </li>
                    <li className="mt-4">
                        <p className="font-bold">Drawing on the Chart – Your Investment Plan on Screen</p>
                        <p>
                            Want to mark key support and resistance levels, define channels, or highlight where you'll enter a position? In this video, you'll learn how to use drawing tools on the chart to track your strategies, plan trades, and better understand market movements.
                        </p>
                    </li>
                </ul>

            </section>

            <section className="py-14 dark-bg-with-gradients">
                <div className='generic-container'>

                    <Heading level={2} className={`big-white-header`}>
                        1. Registration
                    </Heading>

                    <div className="video-container">
                        <video
                            controls
                            src={RegistrationMovie}
                            title="Video Tips For Beginners - Registration"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        ></video>
                    </div>

                </div>
            </section>

            <section className="generic-container py-14 training-item">
                <div className={`text-center`}>
                    <Heading level={2} className={`gradient-header`}>
                        2. Subscription
                    </Heading>
                </div>

                <div className="video-container">
                    <video
                        controls
                        src={SubscriptionMovie}
                        title="Video Tips For Beginners - Subscription"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    ></video>
                </div>

            </section>

            <section className="py-14 dark-bg-with-gradients">
                <div className='generic-container'>

                    <Heading level={2} className={`big-white-header`}>
                        3. Settings AI
                    </Heading>

                    <div className="video-container">
                        <video
                            controls
                            src={SettingsMovie}
                            title="Video Tips For Beginners - Settings AI"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        ></video>
                    </div>

                </div>
            </section>
        </>
    )
}

export default SupportVideo;